import axios from '../../Axios/Default';
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};
const access_token_admin = localStorage.getItem("access_token_admin");
axios.defaults.headers.common["Authorization"] = `Bearer ${access_token_admin}`;


export const getDataListAdmin = (page, perpage, search) => {
  
  const promise = axios.get("/admin/v1/get-all?filterOr=role_code:ADM"+search+"&page="+page+"&perpage="+perpage, [], config);
  return promise;
};


export const getDataListUser = (page, perpage, search) => {
  
  const promise = axios.get("/admin/user/get-all?search="+search+"&page="+page+"&perpage="+perpage, [], config);
  return promise;
};

export const getDataAdminByUsername = (username) => {
  const promise = axios.get("/admin/v1/get-all?filterAnd=username:"+username, [], config);
  return promise;
};

export const getDataRecordUser = (page, perpage, search) => {
  
  const promise = axios.get("/admin/record/get-all?page="+page+"&perpage="+perpage+"&filter=type:user", [], config);
  return promise;
};

export const getDataRecordStation = (page, perpage, search) => {
  
  const promise = axios.get("/admin/record/get-all?page="+page+"&perpage="+perpage+"&filter=type:station", [], config);
  return promise;
};


export const getDataMappingGroup1 = (page, perpage, search) => {
  const promise = axios.get("/admin/user/get-all?filterAnd=group_id:1&page="+page+"&perpage="+perpage+"&search="+search, [], config);
  return promise;
};

export const getDataMappingGroup2 = (page, perpage, search) => {
  const promise = axios.get("/admin/user/get-all?filterAnd=group_id:2page="+page+"&perpage="+perpage+"&search="+search, [], config);
  return promise;
};

export const getDataMappingGroup3 = (page, perpage, search) => {
  const promise = axios.get("/admin/user/get-all?filterAnd=group_id:3&page="+page+"&perpage="+perpage+"&search="+search, [], config);
  return promise;
};

export const getDataMappingGroup4 = (page, perpage, search) => {
  const promise = axios.get("/admin/user/get-all?filterAnd=group_id:4&page="+page+"&perpage="+perpage+"&search="+search, [], config);
  return promise;
};


export const getListGroup = (id) => {
  const promise = axios.get("/admin/user/check-group/"+id, [], config);
  return promise;
};


export const createUser = (payload) => {
  const promise = axios.post("/admin/user/create", payload, config);
  return promise;
};


export const updateUser = (id, payload) => {
  const promise = axios.put("/admin/user/update/"+id, payload, config);
  return promise;
};



export const getUserByUsername = (username) => {
  const promise = axios.get("/admin/user/get/"+username, [], config);
  return promise;
};


export const getDataDashboard = (payload) => {
  const promise = axios.get("/admin/set-station/summary", payload, config);
  return promise;
};


export const getPLTSByUsername = (stasion_code) => {
  const promise = axios.get("/admin/set-station/get/"+stasion_code, [], config);
  return promise;
};